export const ICON_CARD_TEST_ID = {
  card: 'icon-card',
};
